import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class PortfolioProject extends Component {
	render() {
		if (this.props.routeLink) {
			return (
				<div className="col-md-4 col-sm-6 portfolio-item">
					<Link to={this.props.routeLink} className="portfolio-link" data-toggle="modal">
						<div className="portfolio-hover">
							<div className="portfolio-hover-content">
								<i className="fa fa-plus fa-3x"></i>
							</div>
						</div>
						<img
								src={this.props.icon}
								className="img-responsive"
								alt={this.props.iconLabel} />
					</Link>
					<div className="portfolio-caption">
						<h4>{this.props.title}</h4>
						<p className="text-muted">{this.props.desciption}</p>
					</div>
				</div>
			);
		}
		return (
			<div className="col-md-4 col-sm-6 portfolio-item">
				<a href={this.props.link} className="portfolio-link" data-toggle="modal">
					<div className="portfolio-hover">
						<div className="portfolio-hover-content">
							<i className="fa fa-plus fa-3x"></i>
						</div>
					</div>
					<img
							src={this.props.icon}
							className="img-responsive"
							alt={this.props.iconLabel} />
				</a>
				<div className="portfolio-caption">
					<h4>{this.props.title}</h4>
					<p className="text-muted">{this.props.desciption}</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/PortfolioProject.jsx